module.exports = __webpack_public_path__ + "img/blue_101.9f4e0011.png";